import '../../../sass/alpha-modules/optional/_back-to-top.scss'

import AlphaHelpers from '../../abstracts/classes/alpha-helpers'
import AlphaModule from '../../abstracts/classes/alpha-module'

export default class BackToTop extends AlphaModule {
  getName() {
    return 'backToTop'
  }

  constructor(...args) {
    super(...args)

    const config = this.getConfig()

    this._linkEl = document.querySelector(config.linkSelector)
    this._triggerEl = document.querySelector(config.triggerSelector)
    this._focusableElements = AlphaHelpers.smartQuerySelectorAll('button, a:not([id="site-top"]), input, select, textarea, [tabindex]:not([tabindex="-1"])')
  }

  getDefaultConfig() {
    return {
      linkSelector: '.back-to-top-link',
      triggerSelector: '.back-to-top-trigger',
      showClass: 'shown'
    }
  }

  _onLoad() {
    super._onLoad()

    if (this._isValid()) {
      this._handleBackToTopDisplay()
    }
  }

  _handleBackToTopDisplay() {
    const config = this.getConfig()
    const linkEl = this.getLinkElement()
    const triggerEl = this.getTriggerElement()
    if ('IntersectionObserver' in window) {
      // handle button display
      const intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0]
        if (entry.isIntersecting) {
          linkEl.classList.add(config.showClass)
        } else {
          linkEl.classList.remove(config.showClass)
        }

        // inform other components that button state has changed
        this.dispatchEvent('state.changed', {
          isShown: this.isShown()
        })
      })

      intersectionObserver.observe(triggerEl)

      // handle back to top functionality
      linkEl.addEventListener('click', (e) => {
        e.preventDefault()

        linkEl.blur()
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })

        // set focus on the first focusable element (for accessibility)
        // https://jhartshorne.co.uk/posts/back-to-top/
        this._focusableElements[0].focus({
          preventScroll: true
        })
      })
    }
  }

  _isValid() {
    return this.getLinkElement() && this.getTriggerElement()
  }

  isShown() {
    const config = this.getConfig()

    return this.getLinkElement().classList.contains(config.showClass)
  }

  getLinkElement() {
    return this._linkEl
  }

  getTriggerElement() {
    return this._triggerEl
  }
}
